import { BaseEntity } from "yt-ng-framework";
//import { timingSafeEqual } from "crypto";

export class DokumentStavka extends BaseEntity{
    constructor(){
        super();
    }

    DokumentID: number = null;
    RobaID: number = null;
    MagacinID: number = null;
    Serija: string = null;
    DatumIsteka: Date = null;
    Kolicina: number = null;
    NabavnaCena: number = null;
    //NabavnaVrednost: number = null;
    ProdajnaCena: number = null;
    RabatCena: number = null;
    RabatProc: number = null;
    Porez: number = null;
    MpCena: number = null;
    DobavljacCena: number = null;
    UlazniRabatProcenat: number = null;
    Stopa: number = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.DokumentID = this.DokumentID;
        this.RobaID=input.RobaID;
        this.MagacinID=input.MagacinID;
        this.Serija=input.Serija;
        this.DatumIsteka=input.DatumIsteka;
        this.Kolicina=input.Kolicina;
        this.NabavnaCena=input.NabavnaCena;
        //this.NabavnaVrednost=input.NabavnaVrednost;
        this.ProdajnaCena = input.ProdajnaCena;
        this.RabatCena = input.RabatCena;
        this.RabatProc = input.RabatProc;
        this.Porez = input.Porez;
        this.MpCena = input.MpCena;
        this.DobavljacCena = input.DobavljacCena;
        this.UlazniRabatProcenat = input.UlazniRabatProcenat;
        this.Stopa = input.Stopa;
        return this;
    }
    Serialize(input:DokumentStavka){
        return input;
    }
}